import { create } from "zustand";
import {
  AllWarehouses,
  getCommunityDetails,
  getCommunityOrderStats,
  getFlaggedInvoice,
  getOadOrders,
  getProzoPendingOrders,
  getShippingPendingOrders,
  ValidWarehouse,
  processOrder,
  uploadInvoiceInfo,
  updateWarehouse,
  markShippedApi,
  getOrderTrackingInfo,
} from "../api";

export const useOadData = create((set) => ({
  oadData: [],
  isLoading: false,
  error: null,
  fetchOadOrders: async (type, filter, sd, ed) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getOadOrders(type, filter, sd, ed);
      set({ oadData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useFlaggedInvoiceData = create((set) => ({
  flaggedInvoiceData: [],
  isLoading: false,
  error: null,
  fetchFlaggedInvoiceData: async (page, sd, ed, filter) => {
    try {
      set({ isLoading: true, error: null });
      const response = await getFlaggedInvoice(page, sd, ed, filter);
      set({ flaggedInvoiceData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useProcessOrders = create((set) => ({
  processData: [],
  isLoading: false,
  error: null,
  postProcessData: async (orders, setToaster, type = "flagged") => {
    try {
      const response = await processOrder(orders, type);
      set({ processData: response.data, isLoading: false });
      setToaster("Report", `Order processed successfully`, "success");
    } catch (error) {
      setToaster("Report", "Failed to process orders", "danger");
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useProzoPendingOrders = create((set) => ({
  pendingOrders: [],
  isLoading: false,
  error: null,
  prozoPending: async (filter, sd, ed, setToaster) => {
    try {
      const response = await getProzoPendingOrders(filter, sd, ed);
      set({ pendingOrders: response.data, isLoading: false });
    } catch (error) {
      setToaster("Report", `Failed to fetch prozo pending orders`, "danger");
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useShippingPending = create((set) => ({
  flaggedOrders: [],
  isLoading: false,
  error: null,
  shippingPendingOrders: async (page, sd, ed, filter) => {
    try {
      const response = await getShippingPendingOrders(page, sd, ed, filter);
      set({ flaggedOrders: response.data, isLoading: false });
    } catch (error) {
      //   setToaster("Report", `Something went wrong, Request failed!`, "danger");
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useUploadInvoice = create((set) => ({
  uploadInvoiceData: [],
  isLoading: true,
  error: null,
  uploadInvoice: async (page, sd, ed, filter) => {
    try {
      const response = await uploadInvoiceInfo(page, sd, ed, filter);
      set({ uploadInvoiceData: response.data, isLoading: false });
    } catch (error) {
      //   setToaster("Report", `Something went wrong, Request failed!`, "danger");
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useWarehouse = create((set) => ({
  warehouseData: [],
  isLoading: true,
  error: null,
  fetchWarehouseData: async () => {
    try {
      const response = await AllWarehouses();
      set({ warehouseData: response.data, isLoading: false });
    } catch (error) {
      //   setToaster("Report", `Something went wrong, Request failed!`, "danger");
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useValidWarehouse = create((set) => ({
  validWarehouseData: [],
  updatedWarehouseData: [],
  isLoading: true,
  error: null,
  fetchValidWarehouseData: async (orderId) => {
    try {
      const response = await ValidWarehouse(orderId);
      set({ validWarehouseData: response.data, isLoading: false });
    } catch (error) {
      set({ error: error.message, isLoading: false });
    }
  },
  updateWarehouse: async (updatedData, setToaster) => {
    try {
      const response = await updateWarehouse(updatedData);
      set({ updatedWarehouseData: response.data, isLoading: false });
      setToaster(
        "Report",
        `Warehouse updating is in progress, it will take few seconds to complete`,
        "success"
      );
    } catch (error) {
      setToaster("Report", "Failed to update warehouse", "danger");
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useMarkShipped = create((set) => ({
  markedShippedData: [],
  isLoading: false,
  error: null,
  markShipped: async (updatedData, setToaster) => {
    try {
      const response = await markShippedApi(updatedData);
      set({ markedShippedData: response.data, isLoading: false });
      setToaster(
        "Report",
        `Order Shipped`,
        "success"
      );
    } catch (error) {
      setToaster("Report", "Order not shipped", "danger");
      set({ error: error.message, isLoading: false });
    }
  },
}));

export const useOrderTracking = create((set) => ({
	orderTrackingData: [],
	isLoading: false,
	error: null,
	fetchOrderTrackingInfo: async (orderId, setToaster) => {
		try {
			const response = await getOrderTrackingInfo(orderId);
			set({ orderTrackingData: response.data, isLoading: false });
		  } catch (error) {
			setToaster("Report", "Something went wrong in finding tracking info", "danger");
			set({ error: error.message, isLoading: false });
		  }
	}
}))
